module.exports = __webpack_public_path__ + "img/image2.74346ddd.jpg";